(() => {
  const SELECTOR =
    '.section-collection-list .collection-list-wrapper .collection-list';

  /*
   * Framer-style timing
   */
  const AUTOPLAY_DELAY = 4200;
  const RESUME_DELAY = 2800;

  /*
   * Respect accessibility settings
   */
  const reducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) return;


  function initCarousel(list) {

    if (!list || list.dataset.carouselInitialized === 'true') {
      return;
    }

    list.dataset.carouselInitialized = 'true';


    let autoplayTimer = null;
    let resumeTimer = null;

    let isInteracting = false;
    let isScrolling = false;


    /* ---------------------------------------
       GET SLIDES
    --------------------------------------- */

    const getItems = () =>
      Array.from(
        list.querySelectorAll('.collection-list__item')
      );


    /* ---------------------------------------
       CALCULATE CARD STEP
    --------------------------------------- */

    const getStep = () => {

      const item = getItems()[0];

      if (!item) return 0;

      const itemWidth =
        item.getBoundingClientRect().width;

      const styles =
        window.getComputedStyle(list);

      const gap =
        parseFloat(
          styles.columnGap ||
          styles.gap ||
          0
        ) || 0;

      return itemWidth + gap;
    };


    /* ---------------------------------------
       CAN THE CAROUSEL MOVE?
    --------------------------------------- */

    const canScroll = () => {

      return (
        list.scrollWidth >
        list.clientWidth + 5
      );

    };


    /* ---------------------------------------
       GET CURRENT POSITION
    --------------------------------------- */

    const getMaxScroll = () => {

      return (
        list.scrollWidth -
        list.clientWidth
      );

    };


    /* ---------------------------------------
       DETECT END
    --------------------------------------- */

    const atEnd = () => {

      return (
        list.scrollLeft >=
        getMaxScroll() - 8
      );

    };


    /* ---------------------------------------
       MOVE TO NEXT CARD
    --------------------------------------- */

    const moveNext = () => {

      if (
        isInteracting ||
        isScrolling ||
        !canScroll()
      ) {
        return;
      }


      const step = getStep();

      if (!step) return;


      /*
       * When we reach the end,
       * smoothly return to the beginning.
       *
       * The short pause before this makes
       * the loop feel intentional rather than
       * like the carousel suddenly broke.
       */

      if (atEnd()) {

        isScrolling = true;

        list.scrollTo({
          left: 0,
          behavior: 'smooth'
        });

        setTimeout(() => {
          isScrolling = false;
        }, 750);

        return;
      }


      isScrolling = true;

      list.scrollBy({
        left: step,
        behavior: 'smooth'
      });


      /*
       * Prevent another automatic movement
       * while the current one is finishing.
       */

      setTimeout(() => {
        isScrolling = false;
      }, 750);

    };


    /* ---------------------------------------
       START AUTOPLAY
    --------------------------------------- */

    const startAutoplay = () => {

      clearInterval(autoplayTimer);

      if (!canScroll()) return;

      autoplayTimer =
        setInterval(
          moveNext,
          AUTOPLAY_DELAY
        );

    };


    /* ---------------------------------------
       PAUSE
    --------------------------------------- */

    const pauseAutoplay = () => {

      isInteracting = true;

      clearInterval(
        autoplayTimer
      );

      clearTimeout(
        resumeTimer
      );

    };


    /* ---------------------------------------
       RESUME
    --------------------------------------- */

    const resumeAutoplay = () => {

      clearTimeout(
        resumeTimer
      );


      resumeTimer =
        setTimeout(() => {

          isInteracting = false;

          startAutoplay();

        }, RESUME_DELAY);

    };


    /* ---------------------------------------
       TOUCH
    --------------------------------------- */

    list.addEventListener(
      'touchstart',
      pauseAutoplay,
      {
        passive: true
      }
    );


    list.addEventListener(
      'touchend',
      resumeAutoplay,
      {
        passive: true
      }
    );


    list.addEventListener(
      'touchcancel',
      resumeAutoplay,
      {
        passive: true
      }
    );


    /* ---------------------------------------
       MOUSE
    --------------------------------------- */

    list.addEventListener(
      'mouseenter',
      pauseAutoplay
    );


    list.addEventListener(
      'mouseleave',
      resumeAutoplay
    );


    /* ---------------------------------------
       POINTER
    --------------------------------------- */

    list.addEventListener(
      'pointerdown',
      pauseAutoplay
    );


    list.addEventListener(
      'pointerup',
      resumeAutoplay
    );


    /* ---------------------------------------
       DAWN ARROWS
    --------------------------------------- */

    const wrapper =
      list.closest(
        '.collection-list-wrapper'
      );


    if (wrapper) {

      wrapper
        .querySelectorAll(
          '.slider-button'
        )
        .forEach((button) => {

          button.addEventListener(
            'click',
            () => {

              pauseAutoplay();

              resumeAutoplay();

            }
          );

        });

    }


    /* ---------------------------------------
       WINDOW RESIZE
    --------------------------------------- */

    let resizeTimer;

    window.addEventListener(
      'resize',
      () => {

        clearTimeout(
          resizeTimer
        );


        resizeTimer =
          setTimeout(() => {

            if (!isInteracting) {

              startAutoplay();

            }

          }, 500);

      }
    );


    /* ---------------------------------------
       START
    --------------------------------------- */

    startAutoplay();

  }


  /* ---------------------------------------
     FIND COLLECTION CAROUSELS
  --------------------------------------- */

  const findCarousels = () => {

    document
      .querySelectorAll(
        SELECTOR
      )
      .forEach(initCarousel);

  };


  /* ---------------------------------------
     INITIAL LOAD
  --------------------------------------- */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      findCarousels
    );

  } else {

    findCarousels();

  }


  /* ---------------------------------------
     SHOPIFY THEME EDITOR
  --------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    findCarousels
  );

})();